var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShekel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.4,
    height: 7.572,
    viewBox: "0 0 7.4 7.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(-12 -14.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_payment-ils",
    "data-name": "Icon payment-ils",
    d: "M17.408,23.337a.171.171,0,0,1-.173.173h-.861a.17.17,0,0,1-.172-.173V20.669a1.465,1.465,0,0,0-1.463-1.463H13.278v6.2a.171.171,0,0,1-.173.173h-.861a.17.17,0,0,1-.172-.173V18.175A.17.17,0,0,1,12.245,18h2.5a2.667,2.667,0,0,1,2.668,2.667v2.667Zm2.065-.43a2.667,2.667,0,0,1-2.668,2.667h-2.5a.17.17,0,0,1-.172-.173V20.24a.17.17,0,0,1,.172-.173h.861a.171.171,0,0,1,.173.173v4.13h1.462a1.465,1.465,0,0,0,1.463-1.463V18.175A.17.17,0,0,1,18.44,18H19.3a.171.171,0,0,1,.173.173v4.732Z",
    transform: "translate(-0.073 -3.042)",
    fill: "#3e3d3d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekel);
export default __webpack_public_path__ + "static/media/shekel.88673ff9e155a43e0e1e02e3e6415917.svg";
export { ForwardRef as ReactComponent };